import packageInfo from '../../package.json';

export const DEFAULT_ACTIVE_BRANCH_ID = -1;
export const DEFAULT_SELECTED_BRANCH_ROUTE_NUMBER = 'NONE';
export const DEFAULT_SELECTED_DISTRICT_NUMBER = 'NONE';
export const DEFAULT_ACTIVE_DISTRICT = 'NONE';
export const DEFAULT_SELECTED_DAY = 0;
export const IMAGE_PREFIX = 'data:image/png;base64,';
export const EMPTY_API_RESPONSE = {
  data: {
    content: []
  }
};

export const DIRECTION = {
  asc: {
    name: 'asc',
    opposite: 'desc'
  },
  desc: {
    name: 'desc',
    opposite: 'asc'
  }
};

export const DEFAULT_DIRECTION = DIRECTION.asc.name;
export const APP_VERSION = `${process.env.REACT_APP_MODE} v.${packageInfo.version}`;
export const ISO_DATE_FORMAT = 'yyyy-MM-dd';
export const MIME_TYPE = {
  pdf: 'application/pdf',
  zip: 'application/zip',
  csv: 'text/csv'
};

export const MEDIUM_SCREEN_THRESHOLD = 992;

export const MRS_SIZE_CODE = 'MRSEA';
